import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { SensorCalibration } from "@/model/data/logAnalysis/SensorCalibration";

export class GetSensorsCalibrationResData extends ApiGenericResponse {
    sensorCalibration: SensorCalibration[];
    sensorsLabels: Map<number, string>;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.SensorsCalibration) {
            this.sensorCalibration = new Array();
            obj.SensorsCalibration.forEach((element) => {
                let sc = new SensorCalibration();
                sc.parse(element);
                this.sensorCalibration.push(sc);
            });
        }

        if (obj.SensorsLabels) {
            this.sensorsLabels = new Map<number, string>();
            Object.entries(obj.SensorsLabels).forEach((pair: any) => {
                this.sensorsLabels.set(pair[0], pair[1]);
            });
        }
    }
}
